const OrganizationRoles = {
    ManageIdentityProviders: "manage-identity-providers",
    ManageInvitations: "manage-invitations",
    ManageMembers: "manage-members",
    ManageOrganization: "manage-organization",
    ManageRoles: "manage-roles",
    ViewIdentityProviders: "view-identity-providers",
    ViewInvitations: "view-invitations",
    ViewMembers: "view-members",
    ViewOrganization: "view-organization",
    ViewRoles: "view-roles"
};

const RealmManagementRoles = {
    ManageOrganizations: "manage-organizations",
    ManageUsers: "manage-users",
    ManageRoles: "manage-roles"
};

const UserManagementRoles = {
    PermissionAuthorityFull: "permission_authority_full",
    PermissionAuthorityLocalAdmin: "permission_authority_local-admin",
    RoleLocalAdmin: "role_local-admin"
};

export { OrganizationRoles, RealmManagementRoles, UserManagementRoles };
